import Loader from 'components/ui/Loader'
import { getSeriesSponsors, getSeriesSponsorsVariables } from 'graphql/query/__generated__/getSeriesSponsors'
import { GET_SERIES_SPONSORS } from 'graphql/query/getSeriesSponsors'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { useQuery } from '@apollo/client'

import { Content, Description, Header, Title, Wrapper } from './styled'

enum DONATION_PERIOD {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}

const donationPeriodToLabel = {
  [DONATION_PERIOD.DAY]: 'DAILY',
  [DONATION_PERIOD.WEEK]: 'WEEKLY',
  [DONATION_PERIOD.MONTH]: 'MONTHLY',
}

function SeriesSponsor() {
  const { id } = useParams()

  const [currentSponsorType, setCurrentSponsorType] = useState(DONATION_PERIOD.DAY)
  const [currentSponsorIndex, setCurrentSponsorIndex] = useState(0)

  const { data, loading } = useQuery<getSeriesSponsors, getSeriesSponsorsVariables>(GET_SERIES_SPONSORS, {
    variables: { series_id: id },
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (!data?.getSeriesSponsors) return

    const interval = setInterval(() => {
      if (
        data.getSeriesSponsors[currentSponsorType].length === 0 ||
        currentSponsorIndex === data.getSeriesSponsors[currentSponsorType].length - 1
      ) {
        switch (currentSponsorType) {
          case DONATION_PERIOD.DAY:
            setCurrentSponsorType(DONATION_PERIOD.WEEK)
            break

          case DONATION_PERIOD.WEEK:
            setCurrentSponsorType(DONATION_PERIOD.MONTH)
            break

          default:
            setCurrentSponsorType(DONATION_PERIOD.DAY)
        }

        return setCurrentSponsorIndex(0)
      }

      setCurrentSponsorIndex((prev) => prev + 1)
    }, 5000)

    return () => {
      clearInterval(interval)
    }
  }, [currentSponsorIndex, currentSponsorType, data?.getSeriesSponsors])

  const currentSponsor = data?.getSeriesSponsors?.[currentSponsorType]?.[currentSponsorIndex]

  return (
    <Wrapper>
      <Header>{donationPeriodToLabel[currentSponsorType]} SPONSOR</Header>
      <Content>
        {loading ? (
          <Loader color="#FFFFFF" />
        ) : !currentSponsor ? (
          <Title></Title>
        ) : (
          <>
            <Title>{currentSponsor.isAnonymous ? 'Anonymous' : currentSponsor.fullName}</Title>
            {currentSponsor.inMemoryOf && <Description>{currentSponsor.inMemoryOf}</Description>}
          </>
        )}
      </Content>
    </Wrapper>
  )
}

export default SeriesSponsor
